export default __webpack_public_path__ + "static/media/tk_new.c004463b.png";